import axios from 'axios'
import qs from 'qs';

const util = require("../utils/index.js");   //签名
axios.defaults.timeout = 300000;
// create an axios instance
const service = axios.create({
    baseURL: 'https://culture.ggyzkj.com/api',
    // baseURL:'http://localhost:8090',
    timeout: 10000, // request timeout
    // headers: { 'X-Requested-With': 'XMLHttpRequest' },
})

/**
 * 获取请求头信息
 **/
function getHeaders() {
    return {
        "clientType": 'MP-WEIXIN',
        "version": 1,
        "appId": '1234',
        "timestamp": Date.now(),
    };
}

/**
 * 获取签名之后的请求头
 **/
function getsign(_reqObj) {
    var s = ["2", "L", "O", "m", "l", "M", "4", "c", "7", "A", "r", "s", "K", "2", "D", "z", "a", "w", "O", "U", "*", "2", "6", "j", "1", "Q", "a", "L", "Y", "d", "a", "D", "7", "L", "!", "x", "F", "S", "L", "B", "L", "S", "v", "H", "g", "Y", "T", "7", "8", "$", "a", "C", "W", "$", "2", "@", "F", "y", "y", "y", "U", "D", "j", "x", "Y", "&", "a", "t", "P", "E", "Y", "p", "l", "f", "W", "O", "V", "@", "g", "e", "0", "w", "P", "v", "x", "$", "%"];

    const client = new util.client(s.join(""));
    var result;
    if (_reqObj.hasOwnProperty("method") && ("POST" == _reqObj.method || "post" == _reqObj.method)) {
        result = client.post(_reqObj.url, {
            headers: getHeaders(),
            signHeaders: getHeaders(),
            query: _reqObj.headers && _reqObj.headers['Content-Type'] == 'application/json' ? {} : _reqObj.data,
            data: _reqObj.data,
            defaulthead: _reqObj.headers,
        });
    } else {
        result = client.get(_reqObj.url, {
            headers: getHeaders(),
            signHeaders: getHeaders(),
            query: _reqObj.params,
            data: {},
        });
    }
    return result;
}

// 请求拦截器
service.interceptors.request.use(config => {
    console.log("请求拦截", config);
    config.headers = getsign(config);
    if (localStorage.getItem('token')) {
        config.headers['Authorization'] = localStorage.getItem('token') // 让每个请求携带token-- ['Authorization']为自定义key 请根据实际情况自行修改
    }

    // 在发送请求之前做某件事
    if (
        config.method === "post" ||
        config.method === "put" ||
        config.method === "delete"
    ) {
        // 序列化
        if (config.headers['content-type'].indexOf("application/json") == -1) {   //请求头为application/json时
            config.data = qs.stringify(config.data);
        }
    }
    return config
}, error => {
    Promise.reject(error)
})

// 响应拦截器
service.interceptors.response.use(
    response => {

        const {data} = response;
        if (data.code == 4001) {
            console.log("登录超时");
            localStorage.clear();
            window.location.href = "/pages/login";
        }
        if (data) {
            return data
        }
        return Promise.reject(response);
    },
    error => {
        /**
         * 下面的注释为通过response自定义code来标示请求状态，当code返回如下情况为权限有问题，登出并返回到登录页
         * 如通过xmlhttprequest 状态码标识 逻辑可写在下面error中
         */
        console.log('error', error)
        const res = error.response;
        //    console.log(res);

        if (res && res.data) {
            const {code, error, error_description} = res.data;
            // 100401:非法的token; 100412:其他客户端登录了;  100413:Token 过期了;
            if (code === 100401 || code === 100412 || code === 100413) {
                // MessageBox.confirm('操作失败，原因：' + error + '，可以取消继续留在该页面，或者重新登录', '操作提示', {
                //     confirmButtonText: '重新登录',
                //     cancelButtonText: '取消',
                //     type: 'warning'
                // }).then(() => {
                //     removeCookies(_CONST.TOKEN);
                //     location.reload();// 为了重新实例化vue-router对象 避免bug
                // })
            } else {
                let error;
                if (!error) {
                    error = "请求失败，异常： " + res.statusText + ' [' + res.status + ']';
                }
                // message.error(error, 5);
            }
        } else {
            // message.error("请求失败，" + error, 5);
        }
        return Promise.reject(error)
    })

// 请求封装
var httpRequest = {
    // get请求
    get(url, params, headers = {}) {
        return new Promise((resolve, reject) => {
            service({
                method: 'get',
                url: url,
                headers: headers,
                params: params
            }).then(response => {
                // 请求成功
                resolve(response)
            }).catch(err => {
                // 请求失败
                console.log('请求失败', err)
                reject(err)
            })
        })
    },
    // post请求
    post(url, data, headers = {}) {
        return new Promise((resolve, reject) => {
            service({
                method: 'post',
                url: url,
                headers: headers,
                data: data
            }).then(response => {
                // 请求成功
                resolve(response)
            }).catch(err => {
                // 请求失败
                console.log('请求失败', err)
                reject(err)
            })
        })
    }
}

export default httpRequest